import moment from 'moment';
import React from 'react';
import { Document, Font, Image, Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import RobotoBold from '../../assets/Roboto-Bold.ttf';
import Roboto from '../../assets/Roboto-Regular.ttf';
import selectClient from '../../hooks/selectClient';
import faq from '../../images/faq.png';
import list from '../../images/information.png';
import partnerSurvey from '../../images/logo.png';
import mikraSurvey from '../../images/old-mikraLogo.png';
import liderSurvey from '../../images/liderLogo.png';
import payday from '../../images/rating.png';

Font.register({
  family: 'Roboto',
  fonts: [{ src: Roboto }, { src: RobotoBold, fontWeight: 700 }],
});

const styles = StyleSheet.create({
  page: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Roboto',
    paddingTop: 80,
    paddingBottom: 80,
    paddingLeft: 80,
    paddingRight: 80,
  },
  section: {
    display: 'flex',
    flexDirection: 'row',
    fontSize: 12,
  },
  dataWrapper: {
    marginBottom: 30,
  },
  leftSection: {
    paddingBottom: 5,
    flexBasis: '45%',
    marginRight: 20,
  },
  rightSection: {
    paddingBottom: 5,
    flexBasis: '35%',
  },
  title: {
    marginBottom: 10,
    fontSize: 14,
    fontWeight: 700,
  },
  info: {
    fontSize: 10,
    color: 'grey',
  },
  dataInfo: {
    fontSize: 12,
  },
  logo: {
    width: '200px',
    marginBottom: 50,
  },
  titleWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  icon: {
    width: '14px',
    flexBasis: '5%',
    marginRight: 5,
  },
  pitanje: {
    fontSize: 12,
    fontWeight: 700,
    marginTop: 20,
  },
  odgovor: {
    fontSize: 12,
    marginTop: 5,
    textAlign: 'justify',
  },
  faqWrapper: {
    marginTop: 10,
  },
  leftSectionQ: {
    paddingBottom: 5,
    flexBasis: '100%',
  },
  rightSectionQ: {
    paddingBottom: 5,
    flexBasis: '60%',
  },
  footer: {
    marginTop: 20,
    marginBottom: 20,
    display: 'flex',
    flexDirection: 'row',
  },
  footerDown: {
    display: 'flex',
    flexDirection: 'row',
  },
  potpisKlijenta: {
    flexBasis: '35%',
  },
  potpisRadnika: {
    flexBasis: '35%',
  },
  danasnjiDatum: {
    flexBasis: '30%',
  },
});

const pracenjeStyles = StyleSheet.create({
  page: {
    fontFamily: 'Roboto',
    paddingTop: 40,
    paddingBottom: 40,
    paddingLeft: 40,
    paddingRight: 40,
    fontSize: 10,
  },
  title: {
    textAlign: 'center',
    fontSize: 13,
    fontWeight: 700,
    marginBottom: 15,
  },
  sectionTitle: {
    fontSize: 11,
    fontWeight: 700,
    marginTop: 10,
    marginBottom: 5,
  },
  table: {
    borderStyle: 'solid',
    borderTopWidth: 0.5,
    borderLeftWidth: 0.5,
    borderColor: '#000',
    marginBottom: 8,
  },
  tableRow: {
    flexDirection: 'row',
  },
  cellLabel: {
    padding: 4,
    fontSize: 9,
    backgroundColor: '#f0f0f0',
    borderRightWidth: 0.5,
    borderBottomWidth: 0.5,
    borderColor: '#000',
    flex: 1,
  },
  cellValue: {
    padding: 4,
    fontSize: 9,
    borderRightWidth: 0.5,
    borderBottomWidth: 0.5,
    borderColor: '#000',
    flex: 1,
  },
  optionsTable: {
    flexDirection: 'row',
    borderStyle: 'solid',
    borderTopWidth: 0.5,
    borderLeftWidth: 0.5,
    borderColor: '#000',
    marginBottom: 8,
  },
  optionCol: {
    flex: 1,
    padding: 6,
    borderRightWidth: 0.5,
    borderBottomWidth: 0.5,
    borderColor: '#000',
  },
  colHeader: {
    fontSize: 10,
    fontWeight: 700,
    marginBottom: 4,
  },
  optionGroupLabel: {
    fontSize: 9,
    marginTop: 4,
    marginBottom: 2,
  },
  optionRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 2,
  },
  optionLabel: {
    fontSize: 9,
  },
  descArea: {
    borderWidth: 0.5,
    borderColor: '#000',
    minHeight: 80,
    padding: 6,
    marginBottom: 10,
  },
  descQuestion: {
    fontSize: 9,
    fontWeight: 700,
  },
  descAnswer: {
    fontSize: 9,
    marginTop: 2,
    marginBottom: 4,
    textAlign: 'justify',
  },
  inlineRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 10,
    marginBottom: 10,
  },
  footerRow: {
    flexDirection: 'row',
    marginTop: 20,
  },
  footerCell: {
    flex: 1,
    fontSize: 9,
    borderTopWidth: 0.5,
    borderColor: '#000',
    paddingTop: 4,
    marginRight: 8,
  },
  signatureLine: {
    marginTop: 24,
    fontSize: 9,
  },
  header: {
    position: 'absolute',
    top: 20,
    left: 30,
    right: 30,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    borderBottom: '1px solid #999',
    paddingBottom: 5,
  }
});

const Checkbox = ({ checked }) => (
  <View
    style={{
      width: 8,
      height: 8,
      borderWidth: 0.5,
      borderColor: '#000',
      marginRight: 4,
      backgroundColor: checked ? '#000' : undefined,
    }}
  />
);

const Option = ({ label, checked }) => (
  <View style={pracenjeStyles.optionRow}>
    <Checkbox checked={checked} />
    <Text style={pracenjeStyles.optionLabel}>{label}</Text>
  </View>
);

const DataRow = ({ l1, v1, l2, v2 }) => (
  <View style={pracenjeStyles.tableRow}>
    <Text style={pracenjeStyles.cellLabel}>{l1}</Text>
    <Text style={pracenjeStyles.cellValue}>{v1 || ''}</Text>
    <Text style={pracenjeStyles.cellLabel}>{l2}</Text>
    <Text style={pracenjeStyles.cellValue}>{v2 || ''}</Text>
  </View>
);

const PracenjeReport = ({ props }) => {
  const loan = props?.loan?.loanInfo?.loanInfo?.[0];
  const codebtorPhones = props?.loan?.loanInfo?.codebtorPhones || [];
  const codebtorPhonesText = codebtorPhones
    .map((c) => `${c.telefonmob || ''} ${c.telefonfix || ''}`.trim())
    .filter(Boolean)
    .join(', ');
  const clientFullName = `${props?.client?.ime || ''} ${props?.client?.prezime || ''}`.trim();
  const officerFullName = `${props?.officer?.officerIme || ''} ${props?.officer?.officerPrezime || ''}`.trim();
  const datumIsplate = loan?.datumisplate ? moment(loan.datumisplate).format('DD.MM.YYYY.') : '';

  return (
    <Document>
      <Page size="A4" style={pracenjeStyles.page} wrap={true}>
        <View style={styles.header} fixed>
          <Text>O-A5-1-3-3</Text>
        </View>

        <Text style={pracenjeStyles.title}>
          IZVJEŠTAJ O PRAĆENJU MIKROKREDITA I KORISNIKA/SUDUŽNIKA
        </Text>

        <View style={pracenjeStyles.table}>
          <DataRow
            l1="Broj ugovora"
            v1={loan?.brojugovora}
            l2="Dani kašnjenja"
            v2={Math.ceil(loan?.danikasnjenja)}
          />
          <DataRow
            l1="Korisnik mikrokredita"
            v1={clientFullName}
            l2="Datum kontakta"
            v2={moment().format('DD.MM.YYYY.')}
          />
          <DataRow
            l1="Broj telefona korisnika"
            v1={props?.client?.telefon}
            l2="Adresa korisnika"
            v2={loan?.adresa}
          />
          <DataRow
            l1="Broj telefona sudužnika"
            v1={codebtorPhonesText}
            l2="Namjena ulaganja (podatak iz baze)"
            v2={loan?.djelatnost}
          />
          <DataRow
            l1="Kategorija rizika sa stanovišta SPNIFT"
            v1={loan?.rizik}
            l2="Datum odobravanja mikrokredita"
            v2={datumIsplate}
          />
          <DataRow l1="Datum važenja ID" v1={loan?.datumvalidnostiid
            ? moment(loan.datumvalidnostiid).format('DD.MM.YYYY.')
            : ''} l2="" v2="" />
          <DataRow l1="Naziv organizacionog dijela" v1={loan?.org_naziv} l2="" v2="" />
          <DataRow
            l1="Iznos odobrenog mikrokredita"
            v1={loan?.odobreniiznos}
            l2="Isplaćeni iznos mikrokredita"
            v2={loan?.iznos}
          />
        </View>

        <Text style={pracenjeStyles.sectionTitle}>
          Svrha posjete: 1. Postprodaja  2. Namjenska upotreba  3. Kašnjenje  4. SPNiFT
        </Text>

        <View style={pracenjeStyles.optionsTable}>
          <View style={pracenjeStyles.optionCol}>
            <Text style={pracenjeStyles.colHeader}>Postprodaja:</Text>
            <Text style={pracenjeStyles.optionGroupLabel}>Procjena uzimanja novog kredita:</Text>
            <Option checked={props?.answers?.[0]?.odgovor === 'Sigurno će uzeti'} label="Sigurno će uzeti" />
            <Option checked={props?.answers?.[0]?.odgovor === 'Vjerovatno će uzeti'} label="Vjerovatno će uzeti" />
            <Option checked={props?.answers?.[0]?.odgovor === 'Neće uzeti'} label="Neće uzeti" />
            <Text style={pracenjeStyles.optionGroupLabel}>Kredit će uzeti u narednih:</Text>
            <Option checked={props?.answers?.[1]?.odgovor === '1 mjesec'} label="1 mjesec" />
            <Option checked={props?.answers?.[1]?.odgovor === '3 mjeseca'} label="3 mjeseca" />
            <Option checked={props?.answers?.[1]?.odgovor === '6 mjeseci'} label="6 mjeseci" />
            <Option checked={props?.answers?.[1]?.odgovor === '12 mjeseci'} label="12 mjeseci" />
            <Option checked={props?.answers?.[1]?.odgovor === 'Neodređeno'} label="Neodređeno" />
          </View>
          <View style={pracenjeStyles.optionCol}>
            <Text style={pracenjeStyles.colHeader}>Namjenska upotreba:</Text>
            <Option checked={props?.answers?.[2]?.odgovor === 'Preuzet račun/izjava'} label="Preuzet račun/izjava" />
            <Option checked={props?.answers?.[2]?.odgovor === 'Nije preuzet račun/izjava'} label="Nije preuzet račun/izjava" />
            <Text style={pracenjeStyles.optionGroupLabel}>Ocjena namjene:</Text>
            <Option checked={props?.answers?.[3]?.odgovor === 'Mikrokredit namjenski utrošen'} label="Mikrokredit namjenski utrošen" />
            <Option checked={props?.answers?.[3]?.odgovor === 'Mikrokredit nije namjenski utrošen'} label="Mikrokredit nije namjenski utrošen" />
          </View>
          <View style={pracenjeStyles.optionCol}>
            <Text style={pracenjeStyles.colHeader}>Kašnjenje:</Text>
            <Text style={pracenjeStyles.optionGroupLabel}>Razlog kašnjenja:</Text>
            <Option checked={props?.answers?.[4]?.odgovor === 'Kašnjenje primanja'} label="Kašnjenje primanja" />
            <Option checked={props?.answers?.[4]?.odgovor === 'Smanjeni prihodi'} label="Smanjeni prihodi" />
            <Option checked={props?.answers?.[4]?.odgovor === 'Povećani troškovi'} label="Povećani troškovi" />
            <Option checked={props?.answers?.[4]?.odgovor === 'Povećana zaduženja'} label="Povećana zaduženja" />
            <Option checked={props?.answers?.[4]?.odgovor === 'Ostanak bez zaposlenja'} label="Ostanak bez zaposlenja" />
            <Option checked={props?.answers?.[4]?.odgovor === 'Propao Biznis'} label="Propao Biznis" />
            <Option checked={props?.answers?.[4]?.odgovor === 'Smrt korisnika'} label="Smrt korisnika" />
            <Option checked={props?.answers?.[4]?.odgovor === 'Smrt člana domaćinstva'} label="Smrt člana domaćinstva" />
            <Option checked={props?.answers?.[4]?.odgovor === 'Nepoznato'} label="Nepoznato" />
            <Text style={pracenjeStyles.optionGroupLabel}>Procjena mogućnosti naplate:</Text>
            <Option checked={props?.answers?.[5]?.odgovor === 'Sigurna naplata'} label="Sigurna naplata" />
            <Option checked={props?.answers?.[5]?.odgovor === 'Vjerovatna naplata'} label="Vjerovatna naplata" />
            <Option checked={props?.answers?.[5]?.odgovor === 'Otežana naplata'} label="Otežana naplata" />
            <Option checked={props?.answers?.[5]?.odgovor === 'Neće se naplatiti'} label="Neće se naplatiti" />
            <Option checked={props?.answers?.[5]?.odgovor === 'Potrebna izmjena uslova otplate'} label="Potrebna izmjena uslova otplate" />
            <Option checked={props?.answers?.[5]?.odgovor === 'Nepoznato'} label="Nepoznato" />
          </View>
        </View>

        <View style={pracenjeStyles.descArea}>
          <Text style={pracenjeStyles.sectionTitle}>Opis prema razlogu posjete:</Text>
          <Text style={pracenjeStyles.descAnswer}>{props?.answers?.[6]?.odgovor}</Text>
        </View>

        <View style={pracenjeStyles.optionsTable} wrap={false}>
          <View style={pracenjeStyles.optionCol}>
            <Text style={pracenjeStyles.colHeader}>4. SPNiFT</Text>
            <Text style={pracenjeStyles.optionGroupLabel}>
              Izvor prihoda iz kojeg se vrši otplata mikrokredita:
            </Text>
            <Option checked={props?.answers?.[7]?.odgovor === 'Plata iz zaposlenja'} label="Plata iz zaposlenja" />
            <Option checked={props?.answers?.[7]?.odgovor === 'Penzija, invalidnina, pomoć, zakup i slično'} label="Penzija, invalidnina, pomoć, zakup i slično" />
            <Option checked={props?.answers?.[7]?.odgovor === 'Prihodi od poljoprivrede, trgovine, proizvodnje i usluga'} label="Prihodi od poljoprivrede, trgovine, proizvodnje i usluga" />
          </View>
          <View style={pracenjeStyles.optionCol}>
            <Text style={pracenjeStyles.colHeader}>4. SPNiFT</Text>
            <Text style={pracenjeStyles.optionGroupLabel}>
              Da li je došlo do promjene nakon odobravanja mikrokredita u: adresi, izvorima prihoda,
              poslovnim aktivnostima, imovini, radnom ili političkom statusu u odnosu na utvrđenu
              prvobitnu ocjenu rizičnosti korisnika prije uspostave poslovnog odnosa:
            </Text>
            <Option checked={props?.answers?.[8]?.odgovor === 'NE'} label="NE" />
            <Option checked={props?.answers?.[8]?.odgovor === 'DA'} label="DA, opisati promjenu:" />
            <Text style={pracenjeStyles.signatureLine}>______________________________________</Text>
            <Text style={pracenjeStyles.optionGroupLabel}>
              Da li Vi ili drugo lice uplaćuje rate mikrokredita. Ukoliko drugo lice uplaćuje
              navesti u kojem je srodstvu sa klijentom i iz kojeg razloga uplaćuje istu.
            </Text>
            <Text style={pracenjeStyles.optionLabel}>Srodstvo: ______________________________</Text>
            <Text style={[pracenjeStyles.optionLabel, { marginTop: 2 }]}>
              Razlog: ________________________________
            </Text>
            <Text style={pracenjeStyles.optionGroupLabel}>
              Prilikom provjere uplatioca rata od strane trećih lica postoji li sumnja na sumnjive,
              neuobičajene i/ili povezane transakcije:
            </Text>
            <Option checked={props?.answers?.[9]?.odgovor === 'NE'} label="NE" />
            <Option checked={props?.answers?.[9]?.odgovor === 'DA'} label="DA, opisati:" />
            <Text style={pracenjeStyles.signatureLine}>______________________________________</Text>
          </View>
        </View>

        <View style={pracenjeStyles.inlineRow}>
          <Text style={[pracenjeStyles.optionLabel, { fontWeight: 700, marginRight: 12 }]}>
            Način kontakta:
          </Text>
          <View style={{ flexDirection: 'row', alignItems: 'center', marginRight: 16 }}>
            <Checkbox />
            <Text style={pracenjeStyles.optionLabel}>Posjeta</Text>
          </View>
          <View style={{ flexDirection: 'row', alignItems: 'center' }}>
            <Checkbox />
            <Text style={pracenjeStyles.optionLabel}>Ostvareni kontakt</Text>
          </View>
        </View>

        <View style={pracenjeStyles.footerRow}>
          <View style={pracenjeStyles.footerCell}>
            <Text>Potpis nadležnog radnika:</Text>
            <Text style={pracenjeStyles.signatureLine}>{officerFullName}</Text>
          </View>
          <View style={pracenjeStyles.footerCell}>
            <Text>Datum posjete/Ostvareni kontakt:</Text>
            <Text style={pracenjeStyles.signatureLine}>{moment().format('DD.MM.YYYY.')}</Text>
          </View>
          <View style={pracenjeStyles.footerCell}>
            <Text>Potpis korisnika/sudužnika/člana domaćinstva:</Text>
            <Text style={pracenjeStyles.signatureLine}> </Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};


const PDFGenerator = ({ props }) => {
  if (props?.survey?.name == 'Izvještaj o praćenju mikrokredita i korisnika/sudužnika') {
    return <PracenjeReport props={props} />;
  }

  let loan = props?.loan?.loanInfo?.loanInfo[0];

  return (
    <Document>
      <Page size="A4" style={styles.page} wrap={true}>
        <View style={styles.dataWrapper}>
          <View>
            <Image
              src={selectClient() === 'Partner' || selectClient() === 'PartnerMKD' ? partnerSurvey : selectClient() == 'Mikra' ? mikraSurvey : liderSurvey}
              style={styles.logo}
            />
          </View>
          <View style={styles.title}>
            <View style={styles.titleWrapper}>
              <Image src={list} style={styles.icon} />
              <Text>Osnovni podaci</Text>
            </View>
          </View>
          <View style={styles.section}>
            <View style={styles.leftSection}>
              <Text style={styles.info}>Izvještaj</Text>
            </View>
            <View style={styles.rightSection}>
              <Text style={styles.info}>Opis</Text>
            </View>
          </View>
          <View style={styles.section}>
            <View style={styles.leftSection}>
              <Text style={styles.dataInfo}>{props?.survey?.name}</Text>
            </View>
            <View style={styles.rightSection}>
              <Text style={styles.dataInfo}>{props?.survey?.description}</Text>
            </View>
          </View>
          <View style={styles.section}>
            <View style={styles.leftSection}>
              <Text style={styles.info}>Klijent</Text>
            </View>
            <View style={styles.rightSection}>
              <Text style={styles.info}>Radnik</Text>
            </View>
          </View>
          <View style={styles.section}>
            <View style={styles.leftSection}>
              <Text style={styles.dataInfo}>
                {props.client.ime} {props?.client?.prezime}
              </Text>
            </View>
            <View style={styles.rightSection}>
              <Text style={styles.dataInfo}>
                {props.officer.officerIme} {props?.officer?.officerPrezime}
              </Text>
            </View>
          </View>
          <View style={styles.section}>
            <View style={styles.leftSection}>
              <Text style={styles.info}>Mobilni telefon</Text>
            </View>
            <View style={styles.rightSection}>
              <Text style={styles.info}>Fiksni telefon</Text>
            </View>
          </View>
          <View style={styles.section}>
            <View style={styles.leftSection}>
              <Text style={styles.dataInfo}>{props?.client?.telefon ? props?.client?.telefon : '/'}</Text>
            </View>
            <View style={styles.rightSection}>
              <Text style={styles.dataInfo}>{props?.client?.telefonFix ? props?.client?.telefonFix : '/'}</Text>
            </View>
          </View>

          {(selectClient() === 'Partner' || selectClient() === 'PartnerMKD') ? (
            <View>
              <View style={styles.section}>
                <View style={styles.leftSection}>
                  <Text style={styles.info}>GPS adresa</Text>
                </View>
              </View>
              <View style={styles.section}>
                <View style={styles.leftSection}>
                  <Text style={styles.dataInfo}>{props?.location?.gpsAddress ? props?.location?.gpsAddress : '/'}</Text>
                </View>
              </View>
            </View>
          ) : (
            <></>
          )}


        </View>
        {props?.survey?.loanDependency ? (
          <View style={styles.dataWrapper}>
            <View style={styles.title}>
              <View style={styles.titleWrapper}>
                <Image src={payday} style={styles.icon} />
                <Text>Podaci o kreditu</Text>
              </View>
            </View>
            <View style={styles.section}>
              <View style={styles.leftSection}>
                <Text style={styles.info}>Broj ugovora</Text>
              </View>
              <View style={styles.rightSection}>
                <Text style={styles.info}>Djelatnost</Text>
              </View>
            </View>
            <View style={styles.section}>
              <View style={styles.leftSection}>
                <Text style={styles.dataInfo}>{loan?.brojugovora ? loan?.brojugovora : '/'}</Text>
              </View>
              <View style={styles.rightSection}>
                <Text style={styles.dataInfo}>{loan?.djelatnost ? loan?.djelatnost : '/'}</Text>
              </View>
            </View>
            <View style={styles.section}>
              <View style={styles.leftSection}>
                <Text style={styles.info}>Dani kašnjenja</Text>
              </View>
              <View style={styles.rightSection}>
                <Text style={styles.info}>Datum isplate</Text>
              </View>
            </View>
            <View style={styles.section}>
              <View style={styles.leftSection}>
                <Text style={styles.dataInfo}>{loan?.danikasnjenja ? loan?.danikasnjenja : '/'}</Text>
              </View>
              <View style={styles.rightSection}>
                <Text style={styles.dataInfo}>{loan?.datumisplate ? (loan?.datumisplate).substr(0, 10) : '/'}</Text>
              </View>
            </View>
            <View style={styles.section}>
              <View style={styles.leftSection}>
                <Text style={styles.info}>Telefoni sudužnika</Text>
              </View>
            </View>
            <View style={styles.section}>
              <View style={styles.leftSection}>
                {props?.loan?.loanInfo?.codebtorPhones?.length > 0 ? (
                  props?.loan?.loanInfo?.codebtorPhones?.map((codebtor, index) => (
                    <Text style={styles.dataInfo} key={index}>
                      {codebtor.telefonmob} {codebtor.telefonfix}
                    </Text>
                  ))
                ) : (
                  <Text style={styles.dataInfo}>/</Text>
                )}
              </View>
            </View>
          </View>
        ) : (
          <></>
        )}
        <View style={styles.section}>
          <View style={styles.dataWrapper}>
            <View style={styles.title}>
              <View style={styles.titleWrapper}>
                <Image src={faq} style={styles.icon} />
                <Text>Pitanja i odgovori</Text>
              </View>
            </View>

            {props?.answers?.map((answer, i) => (
              <View key={i}>
                <View style={styles.section}>
                  <View style={styles.leftSectionQ}>
                    <Text style={styles.pitanje}>
                      {i + 1}. {answer.pitanje}
                    </Text>
                  </View>
                </View>
                <View style={styles.section}>
                  <View style={styles.leftSectionQ}>
                    <Text style={styles.odgovor}>{answer.odgovor}</Text>
                  </View>
                </View>
              </View>
            ))}
          </View>
        </View>
        <View style={styles.footer}>
          <View style={styles.potpisKlijenta}>
            <Text style={styles.odgovor}>Potpis klijenta:</Text>
          </View>
          <View style={styles.potpisRadnika}>
            <Text style={styles.odgovor}>Potpis radnika:</Text>
          </View>
          <View style={styles.danasnjiDatum}>
            <Text style={styles.odgovor}>Današnji datum:</Text>
          </View>
        </View>
        <View style={styles.footerDown}>
          <View style={styles.potpisKlijenta}>
            <Text style={styles.odgovor}>_________________________</Text>
          </View>
          <View style={styles.potpisRadnika}>
            <Text style={styles.odgovor}>_________________________</Text>
          </View>
          <View style={styles.danasnjiDatum}>
            <Text style={styles.odgovor}>{moment().format('DD.MM.YYYY.')}</Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default PDFGenerator;
